/** 审批类型 */
export enum ApprovalType {
  /** USB外设接入审批 */
  usbDevice = 1,
  /** 敏感文件外发审批 */
  sensitiveFile = 2,
  /** 级联连接审批 */
  cascadeLink = 3,
}

export const ApprovalPath: Record<ApprovalType, string> = {
  /** USB外设接入审批 */
  [ApprovalType.usbDevice]: '/dashboard/usb-policy',
  /** 敏感文件外发审批 */
  [ApprovalType.sensitiveFile]: '/dashboard/sensitive-file-scanning',
  /** 级联连接审批 */
  [ApprovalType.cascadeLink]: '/dashboard/cascade-branch-overview',
}

export interface Content {
  /** 审批类型 */
  approval_type: ApprovalType;
  /** 申请时间 */
  application_time: string;
  /** 申请人名称（登记用户名/下级分支名称） */
  applicant_name: string;
}
